import type { MetadataEvalSampledPage } from 'features/knowledgeDocumentViewer/utils/pageMetadataEvalSampling'

export const EVAL_QUEUE_LOOKAHEAD = 3

export function appendUniqueEvalPages(
  queue: readonly MetadataEvalSampledPage[],
  incoming: readonly MetadataEvalSampledPage[]
): MetadataEvalSampledPage[] {
  const seen = new Set(queue.map((page) => page.page_id))
  const next = [...queue]
  for (const page of incoming) {
    if (seen.has(page.page_id)) continue
    seen.add(page.page_id)
    next.push(page)
  }
  return next
}

export function evalQueueExcludePageIds(
  queue: readonly MetadataEvalSampledPage[],
  visitedPageIds: readonly string[]
): string[] {
  const ids = new Set<string>()
  for (const page of queue) {
    ids.add(page.page_id)
  }
  for (const pageId of visitedPageIds) {
    if (pageId.length > 0) ids.add(pageId)
  }
  return [...ids]
}
